import * as React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const CloseIcon = React.forwardRef(function CloseIcon(props, ref) {
    return (
        <SvgIcon {...props} ref={ref} style={{ cursor: 'pointer' }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.9996 13.3888L6.91917 18.4692C6.72207 18.6663 6.49055 18.7648 6.2246 18.7648C5.95865 18.7648 5.72712 18.6663 5.53002 18.4692C5.33292 18.2721 5.23438 18.0406 5.23438 17.7746C5.23438 17.5087 5.33292 17.2771 5.53002 17.08L10.6104 11.9996L5.53002 6.91918C5.33292 6.72208 5.23438 6.49055 5.23438 6.2246C5.23438 5.95865 5.33292 5.72712 5.53002 5.53002C5.72712 5.33292 5.95865 5.23438 6.2246 5.23438C6.49055 5.23438 6.72207 5.33292 6.91917 5.53002L11.9996 10.6105L17.08 5.53002C17.2771 5.33292 17.5087 5.23438 17.7746 5.23438C18.0406 5.23438 18.2721 5.33292 18.4692 5.53002C18.6663 5.72712 18.7648 5.95865 18.7648 6.2246C18.7648 6.49055 18.6663 6.72208 18.4692 6.91918L13.3888 11.9996L18.4692 17.08C18.6663 17.2771 18.7648 17.5087 18.7648 17.7746C18.7648 18.0406 18.6663 18.2721 18.4692 18.4692C18.2721 18.6663 18.0406 18.7648 17.7746 18.7648C17.5087 18.7648 17.2771 18.6663 17.08 18.4692L11.9996 13.3888Z"
                    fill="#1E1E1E"
                />
            </svg>
        </SvgIcon>
    );
});

export default CloseIcon;
